import {UIPopupController} from '../../ui_popup/UIPopupController'
import {removeURLParams, removeHash} from '../../ui_utils/Utils'
import {UINotificationPanelController} from '../../notifications/UINotificationPanelController'
import {UIAjaxWrapper} from '../../network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../network/UIAPIEndpoints'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {ClientUserState} from '../../ClientUserState'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../analytics/Analytics'
import {UIErrorHandler} from '../../errors/UIErrorHandler'
import {ErrorController} from '../../../../../shared/errors/ErrorController'

export abstract class UIHeaderController {
    readonly notificationPanelController: UINotificationPanelController

    constructor() {
        this.notificationPanelController = new UINotificationPanelController(() => this.setupShuffleLinkInterceptor())
        void this.addFriendRequestsToNotificationPanel()

        UIHeaderController.displayAccountDeletionPopup()
        UIHeaderController.displayRedirectErrors()
    }

    abstract hide(): void
    abstract show(): void

    protected abstract setupShuffleLinkInterceptor(): void

    protected async addFriendRequestsToNotificationPanel() {
        if(ClientUserState.userState == undefined) return

        const friendRequestsResponse = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiFriendRequestsReceived(), undefined)
        if(friendRequestsResponse == undefined) return
        const friendRequests = friendRequestsResponse.json as AjaxDataTypes.FriendRequestReceivedData[]
        const friendRequestsNumber: number = friendRequests !== undefined ? friendRequests.length : 0
        if(friendRequestsNumber === 0) return

        if(this.notificationPanelController == undefined) return

        for(const friendRequestReceived of friendRequests) {
            this.notificationPanelController.addFriendRequestNotification(friendRequestReceived.username, new Date(friendRequestReceived.dateCreated))
        }
    }

    protected static sendPlayNowClickAnalytic() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.NotificationAnalytics,
            category: AnalyticEventCategory.NotificationPanel,
            floatValue: AnalyticEventValue.NotificationPanelShuffleClickPlayNow,
        }
        void CA.sendAnalyticEvent(eventData)
    }

    protected static displayRedirectErrors() {
        const hash = window.location.hash
        if(!hash.startsWith('#error=')) return

        try {
            const encodedError = hash.substring('#error='.length)
            if(!encodedError) return

            const errorString = decodeURIComponent(encodedError)
            if(!errorString) return

            const parsedError = JSON.parse(errorString)
            if(parsedError?.type == undefined) return

            const deserializedError = ErrorController.deserializeErrorData(parsedError)
            if(deserializedError == undefined) return

            UIErrorHandler.handleError(deserializedError)
        } catch(e) {
            // Silently fail if error parsing fails
        } finally {
            removeHash()
        }
    }

    private static displayAccountDeletionPopup() {
        const urlSearchParams = new URLSearchParams(window.location.search)
        if(!urlSearchParams.has('account-deleted')) return

        UIPopupController.createSimplePopup({key: 'strings:popups.accountDeletionConfirmation.title'}, {key: 'strings:popups.accountDeletionConfirmation.body'})
        removeURLParams()
    }
}

